import { render, staticRenderFns } from "./AdOrderTable.vue?vue&type=template&id=22458772&scoped=true"
import script from "./AdOrderTable.vue?vue&type=script&lang=js"
export * from "./AdOrderTable.vue?vue&type=script&lang=js"
import style0 from "./AdOrderTable.vue?vue&type=style&index=0&id=22458772&prod&scoped=true&lang=css"
import style1 from "./AdOrderTable.vue?vue&type=style&index=1&id=22458772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22458772",
  null
  
)

export default component.exports